module.exports = __webpack_public_path__ + "ai-bot-body-yeswpf41d06dd9cc58ff15c5931f21b453cd5.png";